<template>
    <palette v-if="palette" :palette="palette" :isActivePalette="true">
        <div class="mb flex justy-between items-center" slot-scope="{palette}">
			<h3 class="palette__heading editable-text">
				<input class="editable-text__input"
					@change="updateName"
					@keyup.enter="$event.target.blur()"
					:style="paletteInputStyle"
					type="text"
					:value="palette.name">
				<icon-pencil class="editable-text__icon"/>
			</h3>
            <slot></slot>
        </div>
    </palette>
</template>

<script>
	import Palette           from "./Palette";
    import IconPencil        from "../../../../../Lib/Icons/IconPencil";
    import UsesActivePalette from "./UsesActivePalette";
    import Palettes    from "../../../Store/Palettes";
    import PageTracker from "../../../../../App/Data/Store/PageTracker";
    import Transition  from "../../../../../Lib/Objects/Transition";

    export default {
        name: "ActivePalette",
		components: {
			IconPencil,
			Palette
		},
        extends: UsesActivePalette,

        data() {
            return {
                paletteShouldAnimate: false,
            }
        },

        computed: {
            paletteInputStyle() {
                let inputWidth;
                if(this.palette.name.length <= 16) {
                    inputWidth = 15;
                }
                else {
                    inputWidth = this.palette.name.length * 0.75;
                }
                return 'width: ' + inputWidth + 'rem; max-width: 100%;';
            },
        },

        methods: {
            updateName({target: {value: name}}) {
                new Palettes().updatePaletteName(name, this.palette.id);
            },

            shouldPaletteAnimate() {
                let Tracker      = new PageTracker();
                let previousPage = Tracker.getPrevious();

                if(previousPage !== 'colors' && previousPage !== 'code' && previousPage !== 'notes') {
                    this.animatePalette();
                }
            },

            animatePalette() {
                new Transition('.editable-text', 1).fadeIn();
                new Transition('ul.swatches', 0.5).fadeIn();
                new Transition('.horizontal li', 0.5).staggerFadeIn(0.05);
            }
        },

        mounted() {
            this.shouldPaletteAnimate();
        }
    }
</script>

<style scoped>

</style>
